import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-op-union",
  "use": "icon-op-union-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-op-union\"><path fill-rule=\"evenodd\" d=\"M20 4a2 2 0 0 1 2 2v5h4a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h4v-6H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 17H6v5h14zm6-8H12v6h14zm-6-7H6v5h14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol